<template>
  <v-dialog :value="dialogStatus" @input="$emit('input', $event)" width="700" persistent>
    <v-card>
      <v-container>
        <v-card-title>
          <v-layout row wrap>
            <v-flex
              xs10
              sm10
              md10
              class="mt-2 headline"
            >{{ $t('rms_invitation_sent_successfully') }}</v-flex>
            <v-flex xs2 sm2 md2 class="text-xs-right">
              <v-btn small dark color="red" icon @click="dialogStatus = false">
                <v-icon small>$vuetify.icons.rms_close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-card-text class="text-truncate px-0">
          <v-list two-line class="">
            <v-list-tile v-for="(link,index) in created_links" :key="index">
              <v-list-tile-action>
                <span>{{ index + 1 }}.</span>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ link.email }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ link.url }}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-btn
                  flat
                  small
                  color="green"
                  v-clipboard:copy="link.url"
                  v-clipboard:success="copySuccess"
                  v-clipboard:error="copyFail"
                >
                  <v-icon>$vuetify.icons.rms_copy</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-actions class="justify-center mt-1">
          <v-btn dark block color="green" :to="{name: 'ListInvitations'}">{{ $t('created_links_view_details_label') }}</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["dialog", "created_links"],

  computed: {
    dialogStatus: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    copySuccess: function() {
      this.$store.dispatch("availLink/copySuccess");
    },
    copyFail: function() {
      this.$store.dispatch("availLink/copyFail");
    }
  }
};
</script>

<style>
.fullWidthButton {
  width: -webkit-fill-available;
}
</style>
